/* eslint-disable @typescript-eslint/no-explicit-any */

export const DATA_SELECTOR_ATTRS = {
  PAGE: "data-evergage-page",
  ZONE: "data-evergage-zone",

  PRODUCT_ID: "data-evergage-product-id",
  PRODUCT_NAME: "data-evergage-product-name",
  PRODUCT_DESCRIPTION: "data-evergage-product-description",
  PRODUCT_PRICE: "data-evergage-product-price",
  PRODUCT_STOCK: "data-evergage-product-stock",
  PRODUCT_COLOR: "data-evergage-product-color",
  COLOR: "data-evergage-color",

  EMAIL: "data-evergage-email",
  USER_ID: "data-evergage-user-id",
  CUSTOMER_ID: "data-evergage-customer-id",
  FIRST_NAME: "data-evergage-first-name",
  LAST_NAME: "data-evergage-last-name",
  PHONE_NUMBER: "data-evergage-phone-number",
  POSTAL_CODE: "data-evergage-postal-code",
  COUNTRY: "data-evergage-country",
  IS_ANONYMOUS: "data-evergage-is-anonymous",

  BREADCRUMBS: "data-evergage-breadcrumbs",
  BREADCRUMBS_LINK: "data-evergage-breadcrumbs-link",

  IMAGE_URL: "data-evergage-image-url",

  ARTICLE_NAME: "data-evergage-article-name",
  THEME: "data-evergage-theme",

  CATEGORIES: "data-evergage-categories",
  PAGE_COLLECTION: "data-evergage-page-collection",
  CNC: "data-evergage-cnc",
  ACTION: "data-evergage-action",
  FAVORITE_ACTION: "data-favorite-action",

  PRODUCT_SKU: "data-evergage-product-sku",
  WAS_PRICE: "data-evergage-was-price",
  DISCOUNT_AMOUNT: "data-evergage-discount-amount",
  DISCOUNT_TYPE: "data-evergage-discount-type",
  STORE: "data-evergage-store",
  STORE_NAME: "data-evergage-store-name",
  STORE_ID: "data-evergage-store-id",
  COLLECTIONS_FLAGS: "data-evergage-collections-flags",
} as const;

export const PRODUCT_SELECTORS = {
  productId: `[${DATA_SELECTOR_ATTRS.PRODUCT_ID}]`,
  productName: `[${DATA_SELECTOR_ATTRS.PRODUCT_NAME}]`,
  productDescription: `[${DATA_SELECTOR_ATTRS.PRODUCT_DESCRIPTION}]`,
  productPrice: `[${DATA_SELECTOR_ATTRS.PRODUCT_PRICE}]`,
  productStock: `[${DATA_SELECTOR_ATTRS.PRODUCT_STOCK}]`,
  productColor: `[${DATA_SELECTOR_ATTRS.PRODUCT_COLOR}]`,
  imageUrl: `[${DATA_SELECTOR_ATTRS.IMAGE_URL}]`,
  color: `[${DATA_SELECTOR_ATTRS.COLOR}]`,
  productSku: `[${DATA_SELECTOR_ATTRS.PRODUCT_SKU}]`,
  wasPrice: `[${DATA_SELECTOR_ATTRS.WAS_PRICE}]`,
  discountAmount: `[${DATA_SELECTOR_ATTRS.DISCOUNT_AMOUNT}]`,
  discountType: `[${DATA_SELECTOR_ATTRS.DISCOUNT_TYPE}]`,
} as const;

export const USER_SELECTORS = {
  email: `[${DATA_SELECTOR_ATTRS.EMAIL}]`,
  userId: `[${DATA_SELECTOR_ATTRS.USER_ID}]`,
  customerId: `[${DATA_SELECTOR_ATTRS.CUSTOMER_ID}]`,
  firstName: `[${DATA_SELECTOR_ATTRS.FIRST_NAME}]`,
  lastName: `[${DATA_SELECTOR_ATTRS.LAST_NAME}]`,
  phoneNumber: `[${DATA_SELECTOR_ATTRS.PHONE_NUMBER}]`,
  postalCode: `[${DATA_SELECTOR_ATTRS.POSTAL_CODE}]`,
  country: `[${DATA_SELECTOR_ATTRS.COUNTRY}]`,
  isAnonymous: `[${DATA_SELECTOR_ATTRS.IS_ANONYMOUS}]`,
} as const;

export const BREADCRUMB_SELECTORS = {
  breadcrumbs: `[${DATA_SELECTOR_ATTRS.BREADCRUMBS}]`,
  breadcrumbsLink: `[${DATA_SELECTOR_ATTRS.BREADCRUMBS_LINK}]`,
  breadcrumbsAnchor: `[${DATA_SELECTOR_ATTRS.BREADCRUMBS}] a`,
  categories: `[${DATA_SELECTOR_ATTRS.CATEGORIES}]`,
  pageCollection: `[${DATA_SELECTOR_ATTRS.PAGE_COLLECTION}]`,
} as const;

export const PAGE_ZONE_SELECTORS = {
  pageSelector: (page: string) => `[${DATA_SELECTOR_ATTRS.PAGE}="${page}"]`,
  zoneSelector: (zone: string) => `[${DATA_SELECTOR_ATTRS.ZONE}="${zone}"]`,
  theme: `[${DATA_SELECTOR_ATTRS.THEME}]`,
} as const;

export const ACTION_SELECTORS = {
  addToBag: `[data-evergage="add-to-bag"]`,
  searchLocation: `[data-evergage="search-location"]`,
  shareButton: "#share-button",
  favoriteToggle: `[data-evergage="favorite-toggle"]`,
  favoriteAction: `[${DATA_SELECTOR_ATTRS.FAVORITE_ACTION}]`,
  action: `[${DATA_SELECTOR_ATTRS.ACTION}]`,
} as const;

export const ARTICLE_SELECTORS = {
  articleName: `[${DATA_SELECTOR_ATTRS.ARTICLE_NAME}]`,
} as const;
